<template>
  <div>
    <v-dialog
      v-model="number_motive_dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
      mobile-breakpoint="1"
    >
      <v-card v-if="one_check" style="border-radius: 12px;">
        <v-card-title primary-title>
          Editando Número e Motivo
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_returned">
            <v-col class="px-0 pt-3">
              <!-- <v-text-field label="Número do documento" v-model="one_check.number"></v-text-field> -->
              <v-text-field v-model="one_check.number" prepend-icon="mdi-information" label="Número" v-mask="'######'" :rules="[rules.required, rules.ck_number]"></v-text-field>
            </v-col>
            <v-col class="pa-0">
              <v-text-field v-model="one_check.motive" prepend-icon="mdi-information" label="Código do Motivo" :rules="[rules.motive]" type="number" v-mask="'##'"></v-text-field>
              <!-- <v-text-field label="Motivo" v-model="one_check.motive"></v-text-field> -->
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="$emit('closeNumberMotive')" cancel></f-btn>
          <f-btn @click="updateReturnedCheck" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api/index';

export default {
  props: {
    number_motive_dialog: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object
    }
  },
  data() {
    return {
      one_check: {},
      
      rules: {
        required: v => !!v || 'Campo é necessário',
        ck_number: v => !!v && v.length == 6 || 'Deve ter 6 dígitos. Ex: 000123',
        notZero: v=> v != '0.00' || 'Não pode ser zero',
        motive: v => !!v && (v >= 10 && v <= 99) || 'Deve ser entre 10 e 99',
      },
    }
  },
  mounted () {
    ;
  },
  methods: {
    setupOneCheck(){
      this.one_check = {
        ...this.check
      }
    },
    updateReturnedCheck(){
      if (this.$refs.edit_returned.validate()){
        const {id, motive, number} = this.one_check
        let obj = { id, motive, number }
        Api.ReturnedCheck.update(obj).then(r=>{
          // console.log('updated returned check', {r});
          this.$emit('doneUpdate', {...r.data})
          this.addNotification({type: 'success', msg: 'Atualizado com sucesso'})
        })
      }
    },
    ...mapActions({
      
    })
  },
  watch: {
    number_motive_dialog(nv) {
      if (nv) {
        this.setupOneCheck()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
